import { QueryResult } from '@apollo/client'
import { Book } from '@fable/types'
import { useQueryClient } from 'react-query'

export const useBookQuery = (): Book | undefined => {
  const queryClient = useQueryClient()
  const queryData = queryClient.getQueryData(['book-detail']) as QueryResult
  const queryResult = queryData?.data as { response: Book }
  const book = queryResult?.response
  return book
}
